<template>
  <section>
    <button class="button field is-primary pull-right" @click="create">
      <b-icon icon="plus" />
      <span>New</span>
    </button>
    <b-table :data="providers" :loading="loading" striped>
      <template slot-scope="props">
        <b-table-column label="Name" field="name">
          {{ props.row.name }}
        </b-table-column>
        <b-table-column label="Actions" :width="200">
          <router-link :to="`/providers/${props.row.id}/edit`">
            <button class="button">Edit</button>
          </router-link>
          <button @click.prevent="remove(props.row.id, props.index)" class="button">Remove</button>
        </b-table-column>
      </template>
      <template slot="empty" v-if="!loading">
        <empty />
      </template>
    </b-table>
  </section>
</template>

<script>
import http from '@/lib/utils/http'
import Empty from '@/lib/components/Empty'

export default {
  data() {
    return {
      providers: [],
      loading: false,
    }
  },
  components: {
    empty: Empty,
  },
  methods: {
    create() {
      this.$router.push('/providers/new')
    },
    remove(providerId, index) {
      http
        .delete(`providers/${providerId}`)
        .then(() => {
          this.providers.splice(index, 1)
        })
        .catch(() => {})
    },
    test() {
      this.providers.push({})
    },
    load() {
      this.loading = true
      http
        .get('providers')
        .then(resp => (this.providers = resp.data))
        .catch(() => {})
        .then(() => (this.loading = false))
    },
  },
  created() {
    this.load()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Providers/List.vue